//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import TranslatorService from '@/services/translator'

//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'

//
import fields from './fields'

//
export default {
    name: 'purchase-order-update',
    components: {
        ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),
        ...mapState('SnackbarModalModule', ['responseConfirm']),

        /**
         * @description
         * Params to form fields
         *
         * @return     {Object}  form field params
         */
        formParams() {
            return {
                g_branch_office_id: this.user.hr_employee.g_branch_office_id,
                is_service: this.formData.is_service,
                pch_provider_id: this.formData.pch_provider_id,
            }
        },

        /**
         *
         */
        formProps() {
            return {
                editable: false,
                fields: fields(this.formParams),
                loading: this.formBusy,
                switchEdit: this.formData.can_edit,
            }
        },
    },
    data() {
        return {
            formBusy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            resetSnackbarState: 'resetSnackbarState',
            setErrorSnackbar: 'setErrorSnackbar',
            setInfoSnackbar: 'setInfoSnackbar',
            setSuccessSnackbar: 'setSuccessSnackbar',
            setWarningSnackbar: 'setWarningSnackbar',
        }),

        /**
         *
         */
        authorize() {
            return this.formData
                .authorize()
                .attach()
                .then(this.successAuthorize)
        },

        /**
         *
         */
        error(error) {
            this.setErrorSnackbar(
                TranslatorService(PurchaseOrderModel, error.response.data)
            )
        },

        /**
         *
         */
        fetch() {
            PurchaseOrderModel.modeler()
                .find(this.$route.params.id)
                .finally(this.toggleBusy)
                .then(this.setFormData)
        },

        /**
         *
         */
        redirect() {
            return this.$router.push({
                name: this.$route.query.from || 'purchase-order-list',
            })
        },

        /**
         *
         */
        reset() {
            this.toggleBusy().then(this.fetch)
        },

        /**
         *
         */
        setFormData(model) {
            this.formData = model.reset()
        },

        /**
         *
         */
        submit() {
            this.$refs.form
                .setWait(true)
                .then(this.update)
                .then(this.success)
                .then(this.redirect)
                .catch(this.error)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        submitAuthorize() {
            this.setWarningSnackbar({
                title: 'Autorizar',
                message: '¿Confirma la autorización de la orden de compra?',
                confirm: 'autorizar',
            })
        },

        /**
         * @description
         * submit service switch
         */
        submitService() {
            this.formData.collection('pch_selected_purchase_orders').clean()
        },

        /**
         *
         */
        success() {
            this.setSuccessSnackbar('Orden de compra actualizada exitosamente.')
        },

        /**
         *
         */
        successAuthorize() {
            this.setSuccessSnackbar('Orden de compra autorizada exitosamente.')
        },

        /**
         *
         */
        async toggleBusy() {
            this.formBusy = !this.formBusy
        },

        /**
         *
         */
        update(model) {
            return model.toUpdate().save()
        },
    },
    watch: {
        /**
         *
         */
        responseConfirm(val) {
            switch (val) {
                case 'autorizar':
                    return this.$refs.form
                        .setWait(true)
                        .finally(this.resetSnackbarState)
                        .then(this.update)
                        .then(this.authorize)
                        .then(this.redirect)
                        .catch(this.error)
                        .then(this.$refs.form.setWait)
            }
        },
    },
    beforeMount() {
        this.setTitleTopBar('Datos de orden de compra')
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PURCHASE_ORDER')) ctx.$router.push('/')
        })
    },
}
